/**
 * Where is My Order Page
 */
'use strict';

const recaptchaConfig = require('../../recaptchaConfig');
const recaptchaEnabled = $('#recaptcha-container-wimo').length;

function handleRecaptchaResponse(response) {
    const $form = $('.js-wimo-form');
    $('.js-recaptcha-response', $form).val(response); // set recaptcha challenge result to be validated on backend
    submitForm($form);
}

function submitForm($form) {
    const formData = {};
    $($form).find('input[name]').each(function (_, node) {
        formData[node.name] = node.value;
    });
    $.post($form.attr('action'), formData)
        .done(function (data) {
            if (!data.success) {
                showError(true, data.errorHtml, data.isSpecialOrderWarningMessage);
                showSpinner($form, false);
                return;
            }
            showError(false);
            $(document).trigger($.Event('faq.pushDataLayerObject'), [$('.js-find-my-order-button', $form)]);
            window.location.href = data.redirectUrl;
        });
}

function showError(visible, errorMsg, isSpecialOrderWarningMessage){
    const $errorRow = $('#error-form');
    const $specialOrderWarningMessage = $('#special-order-warning-message');
    if (visible) {
        const $errorMessageContainer = isSpecialOrderWarningMessage ? $specialOrderWarningMessage : $errorRow;
        $errorMessageContainer.html(errorMsg).show();
        return;
    }
    $errorRow.html('').hide();
    $specialOrderWarningMessage.html('').hide();
}

function showSpinner(form, shouldShowSpinner) {
    const $findMyOrderButton = $('.js-find-my-order-button', form);
    const $findMyOrderButtonSpinner = $('.js-wimo-landing-page-spinner', $findMyOrderButton);
    if (shouldShowSpinner) {
        $findMyOrderButtonSpinner.addClass('spinner-visible');
        $findMyOrderButton.addClass('button-loading');
        return;
    }
    $findMyOrderButton.removeClass('button-loading');
    $findMyOrderButtonSpinner.removeClass('spinner-visible');
}

function isSpinnerVisible() {
    const $findMyOrderButtonSpinner = $('.js-wimo-landing-page-spinner');
    return $findMyOrderButtonSpinner.hasClass('spinner-visible');
}

function bindEvents() {
    $(document).on('submit', '#find-my-order-form', function (e) {
        e.preventDefault();
        if (isSpinnerVisible()) {
            return; // prevent re-submitting while the spinner is visible
        }

        showSpinner($(this), true);
        showError(false);
        if (recaptchaEnabled) {
            recaptchaConfig.executeForContainer('recaptcha-container-wimo');
            return;
        }
        submitForm($(this));
    });
}

const whereIsMyOrderPage = {
    init: () => {
        bindEvents();
        if (recaptchaEnabled) {
            const recaptchaDefinitions = [recaptchaConfig.buildContainerDefinition($('.js-wimo-form'), 'recaptcha-container-wimo', handleRecaptchaResponse)];
            recaptchaConfig.init(recaptchaDefinitions);
        }
    }
};

module.exports = whereIsMyOrderPage;
